import type { Order } from "@@/shared/orders/order";
import type { Price} from "@@/shared/prices/price";
import { zeroPrice } from "@@/shared/prices/price";
import { sumPrices } from "@@/shared/prices/sum-prices";
import type { DeliveryZoneId } from "../delivery-zone/delivery-zone";
import type { Shipping } from "./shipping";
import type { ShippingSlot } from "./shipping-slot";

type DeliveryPrice = {
    //Price to pay
    price: Price;
    //Regular price
    shippingPrice: Price;
    //Price override from zone
    zonePrice: Price | undefined;
    //Discount price
    discountedPrice: Price | undefined;
    dicountFrom: "ALREADY_ORDERED" | "CODE" | undefined;
};

const shippingPrice = (shipping: Shipping, zoneId?: DeliveryZoneId) => {
    const zonePrices = shipping.zonePrices?.filter(f => f.zoneId === zoneId);

    if (zonePrices && zonePrices.length > 0) {
        return zonePrices[0].price;
    }

    return undefined;
};

const shippingPriceByOrder = (
    shipping: Shipping,
    slot: ShippingSlot | undefined,
    orders: Order[],
    zoneId?: DeliveryZoneId,
    extraCost?: Price,
) => {
    let price = shipping.price;
    const zonePrice = shippingPrice(shipping, zoneId);
    if (zonePrice) price = zonePrice;

    price = sumPrices([price, extraCost ?? zeroPrice]);
    const discountedPrice =
        slot &&
        orders.find(
            o =>
                o.delivery.deliveryMethodType === "HOME_DELIVERY" &&
                o.delivery.shippingId === shipping._id &&
                o.delivery.shippingSlot?._id === slot.slot._id,
        )
            ? zeroPrice
            : undefined;

    if (discountedPrice) price = discountedPrice;

    return {
        price: price,
        shippingPrice: shipping.price,
        dicountFrom: discountedPrice ? "ALREADY_ORDERED" : undefined,
        discountedPrice: discountedPrice,
        zonePrice: zonePrice,
    } as DeliveryPrice;
};

export { shippingPriceByOrder };
export type { DeliveryPrice };
